export default "__VITE_ASSET__lotolP1X__"